import { render, staticRenderFns } from "./EditMapping.vue?vue&type=template&id=6d557f5f"
import script from "./EditMapping.vue?vue&type=script&lang=js"
export * from "./EditMapping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports